import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Homenavbar from '../navbar/index';
import Popup from '../popup/index';
import ResponsiveTable from './ResponsiveTable'; // Import the new component

const Homepage = ({ records, setRecords, popupdata, filterdata }) => {
  const [showModal, setShowModal] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchMessage, setSearchMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 14;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('http://localhost/db_connect.php');
        const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setRecords(sortedData);
      } catch (error) {
        console.error("Error fetching data", error);
        setError("Error fetching data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [setRecords]);

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const displayRecords = filterdata.length > 0 ? filterdata : records;
  const totalRecords = displayRecords.length;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = displayRecords.slice(indexOfFirstRecord, indexOfLastRecord);

  const nextPage = () => setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(totalRecords / recordsPerPage)));
  const prevPage = () => setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));

  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const hasNextPage = currentPage < totalPages;
  const hasPrevPage = currentPage > 1;

  const firstRecordIndex = totalRecords > 0 ? indexOfFirstRecord + 1 : 0;
  const lastRecordIndex = Math.min(indexOfLastRecord, totalRecords);

  return (
    <>
      <Homenavbar setSearchMessage={setSearchMessage} />
      <div className='main custom-bg text-dark urdu-text fs-6'>
        <div>
          <h5 className='urdu-text fs-2 text-center font-weight-bold pt-3 mb-9'>
            <b>آل پاکستان مریدین فہرست حضرت محبوب ذات منڈیر شریف سیداں سیالکوٹ</b>
          </h5>
        </div>
        {searchMessage && (
          <div className="text-center mt-3">
            <p>{searchMessage}</p>
          </div>
        )}
        {!searchMessage && totalRecords > 0 && (
          <ResponsiveTable records={currentRecords} handleRowClick={handleRowClick} />
        )}
        {totalRecords === 0 && !loading && (
          <div className="text-center mt-3">No records found.</div>
        )}
        {loading && (
          <div className="text-center mt-3">Loading...</div>
        )}
        {error && (
          <div className="text-center mt-3 text-danger">{error}</div>
        )}
        <div className="pagination-container">
          <nav style={{ marginTop: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '60%', margin: '0 auto' }}>
            <ul className="pagination justify-content-center text-center d-flex">
              <li className={`page-item ${!hasPrevPage ? 'disabled' : ''}`}>
                <button onClick={prevPage} className="page-link" disabled={!hasPrevPage}>
                  &laquo; Previous
                </button>
              </li>
              <li className="page-item">
                <span className="page-link" style={{ backgroundColor: 'white', color: 'black' }}>
                  <b>Page {currentPage} of {totalPages}</b>
                </span>
              </li>
              <li className={`page-item ${!hasNextPage ? 'disabled' : ''}`}>
                <button onClick={nextPage} className="page-link" disabled={!hasNextPage}>
                  Next &raquo;
                </button>
              </li>
            </ul>
            <p className="text-center mb-3">
              <b>Showing {firstRecordIndex} - {lastRecordIndex} of {totalRecords} records</b>
            </p>
          </nav>
        </div>
      </div>

      <Popup isOpen={showModal} onClose={handleCloseModal} addRecord={setRecords} selectedItem={selectedItem} />
    </>
  );
};

const mapStateToProps = (state) => ({
  records: state.record.records,
  popupdata: state.popupdata.records,
  filterdata: state.filterdata.filteredrecords,
});

const mapDispatchToProps = (dispatch) => ({
  setRecords: (records) => dispatch({ type: 'SET_RECORDS', payload: records })
});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
